import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { QrReader } from 'react-qr-reader'
import { MdFlipCameraAndroid } from 'react-icons/md'

const QRScannerModal = ({ isVisible, onClose, onScanComplete, setError }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [devices, setDevices] = useState([])
    const [selectedDeviceId, setSelectedDeviceId] = useState(null)
    const [showQrReader, setShowQrReader] = useState(true)
    const [currentCameraIndex, setCurrentCameraIndex] = useState(0)

    useEffect(() => {
        const getDevices = async () => {
            try {
                const allDevices = await navigator.mediaDevices.enumerateDevices()
                const videoDevices = allDevices.filter((device) => device.kind === 'videoinput')
                console.log(videoDevices)
                setDevices(videoDevices)
                if (videoDevices.length > 0) {
                    setSelectedDeviceId(videoDevices[0].deviceId)
                }
            } catch (error) {
                console.error('Error fetching devices:', error)
                setError('Error fetching camera devices')
            }
        }

        getDevices()
    }, [setError])

    const handleResult = (result, error) => {
        if (result) {
            
            const url = result?.text
            if (url) {
                try {
                    const parsedUrl = new URL(url)
                    const uValue = parsedUrl.searchParams.get('u')
                    // Check if "awc-inc" is part of the domain
                    if (parsedUrl.hostname.includes('awc-inc')) {
                        if (uValue) {
                            onScanComplete(uValue)
                            handleClose()
                        } else {
                            console.log('u parameter not found in the URL.')
                            setError('AWCID was not found in the URL.')
                        }
                    } else {
                        console.log('URL domain does not contain "awc-inc".')
                        setError('QR invalid: URL domain does not contain "awc-inc".')
                        handleClose()
                    }
                } catch (e) {
                    console.error('Invalid URL:', e.message)
                    setError('Invalid QR code')
                }
            }
        }
    }

    const handleError = (err) => {
        console.error(err)
    }

    const handleClose = () => {
        setSearchTerm('')
        onClose()
    }

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value)
    }

    const toggleCamera = () => {
        if (devices.length > 1) {
            const nextCameraIndex = (currentCameraIndex + 1) % devices.length
            setCurrentCameraIndex(nextCameraIndex)
            setSelectedDeviceId(devices[nextCameraIndex].deviceId)

            setShowQrReader(false)
            setTimeout(() => {
                setShowQrReader(true)
            }, 100)
        }
    }

    if (!isVisible) {
        return null
    }

    return (
        <Modal
            show={true}
            backdropClassName='veil'
            animation={false}
            centered
            autoFocus={false}
            onHide={handleClose}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>QR Scanner</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p
                    style={{
                        marginBottom: '20px',
                        textAlign: 'center',
                        fontSize: '14px',
                        color: '#555',
                    }}
                >
                    Point your camera at the QR code to scan it automatically. If you know the
                    AWC ID, you can enter it manually in the field below.
                </p>

                {/* Camera Flip Icon */}
                {devices.length > 1 && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end', // Align the icon to the right
                            marginBottom: '10px',
                        }}
                    >
                        <button
                            onClick={toggleCamera}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '24px',
                            }}
                        >
                            <MdFlipCameraAndroid />
                        </button>
                    </div>
                )}

                {showQrReader && (
                    <div style={{ marginBottom: '5px' }}>
                        <QrReader
                            delay={300}
                            onError={handleError}
                            onResult={handleResult}
                            constraints={{
                                deviceId: selectedDeviceId
                                    ? { exact: selectedDeviceId }
                                    : undefined,
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                )}

                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <input
                        type='text'
                        placeholder='Enter AWC ID'
                        onChange={handleInputChange}
                        value={searchTerm}
                        style={{ padding: '10px', flex: 1 }}
                    />
                    <button
                        className='btn btn-success'
                        onClick={() => {
                            onScanComplete(searchTerm)
                            handleClose()
                        }}
                        style={{ padding: '10px 20px', cursor: 'pointer' }}
                    >
                        Search
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default QRScannerModal
